import { moduleRegistry } from "./lib/registry";

import "./utils/rating.ts";

import { Nav } from "./components/nav";
import { CookieConsent } from "./components/cookieConsent";
import { Theme } from "./context/theme";
import { Module } from "./lib/modules";
import { Article } from "./pages/article";
import { Articles } from "./pages/articles";
import { Home } from "./pages/home";
import { Login } from "./pages/login";
import { Author } from "./pages/author";
import { matchesPath } from "./utils/matchPath";
import { Rating } from "./pages/rating";
import { ImageSkeleton } from "./components/imageSkeleton";

document.addEventListener("DOMContentLoaded", () => {
  initModules();
});

initPreloadModules();

function initPreloadModules() {
  const modules: Module[] = [Theme];

  for (const module of modules) {
    try {
      const instance = module();
      moduleRegistry.register(instance.name, instance);

      if (!shouldRunModule(instance)) continue;

      instance.init();
    } catch (error) {
      console.error("Error initializing modules:", error);
    }
  }
}

function initModules() {
  console.log("Video Games Made Me Log It");

  const modules: Module[] = [Nav, CookieConsent, ImageSkeleton, Home, Article, Articles, Login, Rating, Author];

  let loadedModules = 0;

  for (const module of modules) {
    try {
      // Check if the module is already registered
      if (moduleRegistry.get(module.name)) continue;

      const instance = module();
      moduleRegistry.register(instance.name, instance);

      if (!shouldRunModule(instance)) continue;

      instance.init();
      loadedModules++;
    } catch (error) {
      console.error("Error initializing modules:", error);
    }
  }

  // console.log(`Loaded ${loadedModules} out of ${modules.length} modules for page: ${window.location.pathname}`);
}

function shouldRunModule(instance: { pages?: string[]; pageBlacklist?: string[] }) {
  if (instance.pages) {
    return instance.pages.some((p) => matchesPath(p, window.location.pathname));
  }

  if (instance.pageBlacklist) {
    return !instance.pageBlacklist.some((p) => matchesPath(p, window.location.pathname));
  }

  return true;
}
